/**
 * 將字串轉換為 URL 物件，若無效則回傳 null
 * @param url - 要轉換的 URL 字串
 * @returns URL 物件或 null
 * @example toUrlObjectOrNull('https://example.com') // URL object
 * @example toUrlObjectOrNull('invalid-url') // null
 */
export const toUrlObjectOrNull = (url: string) => {
  try {
    return new URL(url);
  } catch {
    return null;
  }
};
